import React from 'react';

export type IDialogState<T> = {
  isOpen: boolean;
  data: T;
  open: (v?: T) => void;
  close: () => void;
  change: (v?: T) => void;
  props: {
    open: boolean;
    data: T;
    onClose: (e: React.MouseEvent<HTMLElement>) => void;
  }
};

// eslint-disable-next-line
export const useDialogState = <T extends any>(initialState: T = (undefined as any)): IDialogState<T> => {
  const [open, setOpen] = React.useState(false);
  const [state, setState] = React.useState<T>(initialState);

  return {
    isOpen: open,
    data: state,
    open(data?: T): void {
      setOpen(true);

      if (data) {
        setState(data);
      }
      else if (initialState) {
        setState(initialState);
      }
    },
    close(): void {
      setOpen(false);
    },
    change(data?: T): void {
      if (data) {
        setState(data);
      }
      else if (initialState) {
        setState(initialState);
      }
    },
    props: {
      open,
      data: state,
      onClose: (e: React.MouseEvent<HTMLElement>): void => {
        setOpen(false);
      },
    },
  };
};
